module.exports = "/assets/16fd0da5c2c8798c7e209ec1c0f1c9a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/NP.png
// module id = 1654
// module chunks = 0